var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"Avatar",style:({width: _vm.dim+'px', height: _vm.dim+'px', background:_vm.background, borderRadius: _vm.dim+'px'})},[_c('div',[_vm._v(_vm._s(_vm.firstName[0])+_vm._s(_vm.lastName[0]))])])}
var staticRenderFns = []

export { render, staticRenderFns }